import React from 'react';
import {Box, Typography} from '@mui/material';

/**
 * Read-only classification display field
 * Shows the maximum classification level in the document
 * This value is automatically synchronized from the classification marks in the document
 * @param {Object} props
 * @param {Object|string} props.value - Classification value (object {value, label} or legacy string)
 */
export default function ClassificationField({value}) {
    const plainValue = value && typeof value.toJSON === 'function' ? value.toJSON() : value;

    // Extract display value from object or string.
    const displayValue = typeof plainValue === 'object' && plainValue !== null
        ? (plainValue.label || plainValue.value || '')
        : plainValue;
    const isEmpty = !displayValue;

    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
            <Typography variant="body2" color="text.secondary" sx={{minWidth: '150px', flexShrink: 0}}>
                Classification:
            </Typography>
            <Typography variant="body1" fontWeight={600} sx={{lineHeight: 1.5, flex: 1, minWidth: 0, color: isEmpty ? 'primary.main' : 'text.primary'}}>
                {displayValue}
            </Typography>
        </Box>
    );
}

